module.exports = __webpack_public_path__ + "static/media/ic_show_web_rtv.008afaba.svg";